import * as env from "./env"

let auth0Provider
/**
 * Used to call getAccessTokenSilently
 * @param {object} newAuth0Provider
 */
export const setAuth0Provider = (newAuth0Provider) => {
  auth0Provider = newAuth0Provider
}

/**
 * Returns auth0Provider.getAccessTokenSilently or undefined if authentication hasn't finished
 */

export const getAccessToken = async () => {
  if (!auth0Provider) {
    console.error("setAuth0Provider must be set before calling getAccessToken().")
    return null
  }

  try {
    const audience = env.getAuth0Audience()

    return await auth0Provider.getAccessTokenSilently({
      audience,
    })
  } catch (e) {
    if (e.error === "login_required") {
      await auth0Provider.loginWithRedirect({
        appState: { returnTo: window.location.pathname + window.location.search },
      })
    }

    console.error("Error calling getAccessToken:", e)
    return null
  }
}

/**
 * @returns {string} user's email
 */
export const getUserEmail = () => {
  if (auth0Provider) {
    return auth0Provider.user.email
  } else {
    throw new Error("setAuth0Provider must be set before calling getUserEmail().")
  }
}
